import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-partner-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
})
export class PartnerIntroComponent {
  public getAltText =
    this.translate.currentLang === 'th'
      ? 'สำนักงานบัญชีพาร์ตเนอร์ FlowAccount'
      : 'FlowAccount Accounting Partner Office'
  constructor(public translate: TranslateService) {}
  scrollToTarget(targetId: string) {
    const targetElement = document.getElementById(targetId)
    if (targetElement) {
      const offset = targetElement.offsetTop - (window.innerWidth < 1170 ? 100 : 130)
      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      })
    }
  }
}
